export default __webpack_public_path__ + "static/090-1c6c827de0ed8ecc78f3b5c68ae2500a.jpg";